import Vue from 'vue'
import { getUrl } from './get-url.js'
import axios from "axios";

let isAuthenticated = false
let onLoginCallbacks = []

export default {
    isAuthenticated: function () {
        return isAuthenticated
    },
    token: function (credentials) {
        return new Promise((resolve, reject) => {
            Vue.http.post(getUrl('/token'), JSON.stringify(credentials))
                .then((res) => {
                    isAuthenticated = true
                    Vue.http.headers.common['Authorization'] = 'Bearer ' + res.body.token
                    onLoginCallbacks.forEach(cb => cb({ email: credentials.email }))
                    localStorage.setItem('accessToken', res.body.token)
                    resolve(res)
                }, reject)
        })
    },
    logout: function () {
        return Promise.resolve(() => {
            isAuthenticated = false
            delete Vue.http.headers.common['Authorization']
        })
    },
    recover: function (email) {
        return new Promise((resolve, reject) => {
            axios.post(getUrl('/users/recover'), {
                email: email,
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error)
            })
        })
    },
    editPassword: function (params) {
        return new Promise((resolve, reject) => {
            axios.post(getUrl('/users/editPassword'), {
                password: params.password,
                user_id: params.user_id,
                token: params.token,
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error)
            })
        })
    },

    getUserByToken: function (params) {
        return Vue.http.get(getUrl('/users/getUserByToken/' + params.token));
    },

    getToken: function (params) {
        return Vue.http.get(getUrl('/users/getForgetPasswordToken/' + params.user_id + '/' + params.token));
    },

    registerOnLogin: function (callback) {
        if (typeof callback === 'function') {
            onLoginCallbacks.push(callback)
        }
    },
    unregisterOnLogin: function (callback) {
        const callbackIndex = onLoginCallbacks.indexOf(callback) >= 0
        if (callbackIndex) {
            onLoginCallbacks.splice(callbackIndex, 1)
        }
    },
}



// WEBPACK FOOTER //
// ./src/services/authentication.js